import React from 'react';
import { Box, Checkbox, Typography } from '@mui/material';
import { APP_CONFIG } from '../../../config/app.config';
import { addTransparency, darkenColor } from '../../../application/styles/colorStyles';


interface FilterSelectOptionProps {
  label: string;
  checked: boolean;
  image?: string;
  onChange: (checked: boolean) => void;
  color?: string;
}

const FilterSelectOption: React.FC<FilterSelectOptionProps> = ({
  label,
  checked,
  image,
  onChange,
  color = APP_CONFIG.ui.theme.colors.primaryText,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        alignItems: 'center',
        backgroundColor: addTransparency(color),
        borderColor: color,
        borderWidth: 1,
        opacity: checked ? 1 : 0.75,
        borderStyle: 'solid',
        color: darkenColor(color,50),
        borderRadius: 1,
        py: 0.5,
        px: 1,
        cursor: 'pointer',
        transition: 'opacity 0.2s ease',
        '&:hover': {
          opacity: 1
        }
      }}
      onClick={() => onChange(!checked)}
    >
      {image && (
        <Box sx={{ width: 24, height: 24, mr: 1 }}>
          <img src={image} alt={label} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </Box>
      )}
      <Checkbox
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        sx={{
          color: color,
          '&.Mui-checked': {
            color: color,
          },
          padding: 0
        }}
      />
      <Typography
        variant="body2"
      >
        {label}
      </Typography>
    </Box>
  );
};

export default FilterSelectOption; 